import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { routes } from '@/features/v2/constants/routes';

import { useAuthStore } from '@/stores/userStore';

import './buttonDeposit.css';

const ButtonDeposit = () => {
  const { account } = useAuthStore();

  const router = useRouter();

  const handleDeposit = () => {
    if (account?.contingencies?.deposits) {
      router.push('/?cont=4');
    } else {
      router.push(routes.DEPOSIT);
    }
  };

  return (
    <div>
      <button
        type="button"
        className="flex items-center rounded-xl p-[1px] pl-4 h-10 z-0 mr-2 md:mr-5 relative overflow-hidden group"
        onClick={handleDeposit}
      >

        <div className="deposit-container !bg-transparent">
          <Image
            src="/img/v2/icons/depositIcon.webp"
            alt="depositIcon"
            width={32}
            height={32}
            layout="fixed"
            priority
            className="deposit-icon"
          />
          <div className="deposit-box">
            <p className="deposit-text text-sm font-bold text-hsecondary-50">Depositar</p>
          </div>
        </div>
      </button>
    </div>
  );
};

export default ButtonDeposit;
